import { render, staticRenderFns } from "./ConsultaMotivos.vue?vue&type=template&id=1d6864b2&"
import script from "./ConsultaMotivos.vue?vue&type=script&lang=js&"
export * from "./ConsultaMotivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports